import React, { useEffect, useState } from 'react';
import api from '../../services/api';

import { Container, ContainerAgreements } from './styles';

const Agreements: React.FC = () => {
  const [agreements, setAgreements] = useState("");
  useEffect(() => {
    async function getAgreements() {
      try {
        const { data } = await api.post('/layout/agreements', {
          "type": "1",
          "version": "1.0"
        });
        setAgreements(data.data.content);
      } catch (error) {
        alert("Ocorreu um erro ao buscar os termos");
      }
    }
    getAgreements();
  }, []);

  return (
    <Container>
      <ContainerAgreements dangerouslySetInnerHTML={{
        __html: agreements && agreements
      }} />
    </Container>
  );
}

export default Agreements;
